// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => ("static/css/" + chunkId + "." + {"31":"238e0ad0","836":"6b55d5f9"}[chunkId] + ".chunk.css");